import { isMessageFileMailboxInfo } from "owa-client-types/lib/MessageFileMailboxInfo";
import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";

/**
 * Prefix used to identify message file IDs
 */
export const MESSAGE_FILE_ID_PREFIX = "fileId:";

/**
 * Check if an item is a locally parsed message file
 * @param mailboxInfo - The mailbox info to check
 * @param itemId - The item ID to check
 * @returns true if the item is a locally parsed message file
 */
export function isLocallyParsedMessageFile(mailboxInfo: MailboxInfo | undefined, itemId: string | undefined): boolean {
    return (isMessageFileMailboxInfo(mailboxInfo) &&
        isGlobalFeatureEnabled("mon-msg-local-parser") &&
        !!itemId?.startsWith(MESSAGE_FILE_ID_PREFIX));
}
